export const ticketData = {
  tickets: {
    HU: 'Elővételes Jegyek',
    EN: 'Presale Tickets',
    RS: 'Ulaznice',
  },
  buy: {
    HU: 'Megvásárolom',
    EN: 'Buy',
    RS: 'Kupi',
  },
  position: {
    HU: {
      x: '51.03',
      y: '310.682',
    },
    EN: {
      x: '109.148',
      y: '310.682',
    },
    RS: {
      x: '90.148',
      y: '310.682',
    },
  },
  positionComm: {
    HU: 'translate(37.19 256.97)',
    EN: 'translate(97.19 256.97)',
    RS: 'translate(90.19 256.97)',
  },
  groupText1: {
    HU: 'Kizárólag 5 személyes ',
    EN: 'Only available in a pack of 5,',
    RS: 'Dostupna samo za grupu od 5',
  },
  groupText2: {
    HU: 'csoportoknak Vajdaságban',
    EN: 'locally in Vojvodina',
    RS: 'osoba u Vojvodini',
  },
  oromText1: {
    HU: 'Kizárólag Orom, Újfalu ',
    EN: 'For the residents of Orom,',
    RS: 'Iskljucivo za gradane Oroma,',
  },
  oromText2: {
    HU: 'és Völgyes lakosai számára',
    EN: 'Dolone and Novo Selo',
    RS: 'Dolina i Novog Sela',
  },
  communityLocations: [
    {
      name: 'Zentropia',
      fb: 'https://www.facebook.com/zentropia.official',
      ig: 'https://www.instagram.com/zentropia.official/',
      HU: 'ZENTA',
      EN: 'SENTA',
      RS: 'SENTA',
    },
    {
      name: 'Beerabilly Brew House',
      fb: 'https://www.facebook.com/beerabilly',
      ig: 'https://www.instagram.com/the_beerabilly/',
      HU: 'Óbecse',
      EN: 'Becej',
      RS: 'Becej',
    },
    {
      name: 'Hello Kanjiža',
      fb: 'https://www.facebook.com/hellokanjiza',
      ig: 'https://www.instagram.com/hellokanjiza/',
      HU: 'Magyarkanizsa',
      EN: 'Kanjiza',
      RS: 'Kanjiža',
    },
    {
      name: 'Klein House Wine Bar & Shop',
      fb: 'https://www.facebook.com/kleinhouse.winebar',
      ig: 'https://www.instagram.com/kleinhouse.winebar/',
      HU: 'Szabadka',
      EN: 'Subotica',
      RS: 'Subotica',
    },
    {
      name: 'Grand Café',
      fb: 'https://www.facebook.com/grandcafeszeged',
      ig: 'https://www.instagram.com/grandcafeszeged/',
      HU: 'Szeged',
      EN: 'Seged',
      RS: 'Segedin',
    },
    {
      name: 'Néma Papagáj Lemezbolt',
      fb: 'https://www.facebook.com/nemapapagajrecords',
      ig: 'https://www.instagram.com/nemapapagajrecords/',
      HU: 'Szeged',
      EN: 'Seged',
      RS: 'Segedin',
    },
    {
      name: 'Auróra',
      fb: 'https://www.facebook.com/auroraunofficial',
      ig: 'https://www.instagram.com/aurora_modularis/',
      HU: 'Budapest',
      EN: 'Budapest',
      RS: 'Budimpešta',
    },
    {
      name: '24 bar & coffee',
      ig: 'https://www.instagram.com/24bar____/',
      HU: 'Újvidék',
      EN: 'Novi Sad',
      RS: 'Novi Sad',
    },
  ],

  gateTickets: {
    HU: 'Jegyek a helyszínen',
    EN: 'Tickets at gate',
    RS: 'Ulaznice na lokaciji',
  },
  threeday: {
    HU: 'Bérlet',
    EN: '3-day ticket',
    RS: 'Trodevna ulaznica ',
  },
  family: {
    HU: 'Családi jegy',
    EN: 'Family ticket',
    RS: 'Porodična ulaznica',
  },
  daily: {
    HU: 'Napijegy ',
    EN: 'Daily ticket',
    RS: 'Dnevna ulaznica',
  },
  sale: {
    HU: 'Vásárolj 4-et és 5-öt kapsz! Augusztus 2-ig!',
    EN: 'Buy 4, get 5! Until  2nd August!',
    RS: 'Kupiš 4, dobiješ 5! Do 2-og avgusta!',
  },
  links: {
    gigstixLink: 'https://new.gigstix.com/event/malomfesztival-orom-avgust-2025/',
    tixaLink: 'https://tixa.hu/malomfesztival2025',
  },

};
